"use client";

import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp } from "@fortawesome/free-solid-svg-icons";

export function ScrollBackTopButton() {
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      setShowButton(window.scrollY > 300);
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <button
      onClick={scrollToTop}
      className={`cursor-pointer fixed bottom-5 right-5 z-50 bg-white text-background-grey rounded hover:bg-primary-yellow transition-colors flex items-center justify-center w-12 h-12 shadow-md ${
        !showButton ? "opacity-0" : "opacity-100"
      }`}
      aria-label="Scroll back to top"
    >
      <FontAwesomeIcon icon={faArrowUp} />
    </button>
  );
}
